<template>
  <div class="negocio">
    <header class="negocio__barra">
      <a class="negocio__marca" href="/" title="Volver al mapa">
        <strong>POLZ</strong> <span>Comando</span>
      </a>

      <nav class="negocio__categorias" aria-label="Categorías">
        <button
          v-for="c in categorias"
          :key="c.id"
          type="button"
          class="negocio__categoria"
          :class="{ 'negocio__categoria--activa': categoria && c.id === categoria.id }"
          @click="elegirCategoria(c)"
        >{{ c.nombre }}</button>
      </nav>

      <div class="negocio__barra-acciones">
        <a class="negocio__icono negocio__icono--azul" href="/" title="Mapa"><i class="mdi mdi-home"></i></a>
        <button class="negocio__icono negocio__icono--rojo" type="button" title="Salir" @click="salir">
          <i class="mdi mdi-logout"></i>
        </button>
      </div>
    </header>

    <template v-if="categoria">
      <div class="negocio__subbarra">
        <div class="negocio__fases">
          <button
            type="button"
            class="negocio__fase negocio__fase--home"
            :class="{ 'negocio__fase--home-activa': enHome }"
            @click="elegirHome"
          >
            🏠 HOME
            <span class="negocio__urgentes" title="Unidades con urgencia crítica o alta">{{ urgentes }}</span>
          </button>
          <button
            v-for="f in categoria.fases"
            :key="f.id"
            type="button"
            class="negocio__fase"
            :class="{ 'negocio__fase--activa': !enHome && fase === f.id, 'negocio__fase--out': f.fuera_de_flujo }"
            @click="elegirFase(f.id)"
          >{{ etiquetaFase(f) }}</button>
        </div>
        <div class="negocio__subbarra-lado">
          <div class="negocio__buscar">
            <i class="mdi mdi-magnify"></i>
            <input v-model="q" type="search" placeholder="Buscar terreno o cliente…" @input="buscarLuego">
          </div>
          <button class="negocio__boton negocio__boton--crear" type="button" @click="abrirNueva()">+ Unidad de Negocio</button>
          <button class="negocio__boton negocio__boton--planilla" type="button" @click="abrirPlanilla(false)">📑 Planilla Master</button>
          <button
            class="negocio__boton negocio__boton--gris"
            type="button"
            title="Informe de trazabilidad y aperturas de las INFO enviadas"
            @click="informe = { categoria: categoria.id, titulo: categoria.nombre }"
          >📊 Envíos</button>
        </div>
      </div>

      <div class="negocio__filtros">
        <div class="negocio__gestores">
          <button type="button" class="negocio__gestor" @click="gestor = null">
            <span class="negocio__gestor-avatar negocio__gestor-avatar--todos" :class="{ 'negocio__gestor-avatar--activo': gestor === null }">ALL</span>
            <span>Todos</span>
          </button>
          <button
            v-for="g in gestores"
            :key="g.id"
            type="button"
            class="negocio__gestor"
            :title="`Filtrar por ${g.nombre}`"
            @click="gestor = g.id"
          >
            <span class="negocio__gestor-avatar" :class="{ 'negocio__gestor-avatar--activo': gestor === g.id }">
              <i class="mdi mdi-account"></i>
            </span>
            <span>{{ g.nombre }}</span>
          </button>
        </div>
        <div class="negocio__semaforos">
          <button
            type="button"
            class="negocio__pildora negocio__pildora--todas"
            :class="{ 'negocio__pildora--activa': semaforo === undefined }"
            title="Todos los estados"
            @click="semaforo = undefined"
          >A</button>
          <button
            v-for="s in semaforos"
            :key="s.id"
            type="button"
            class="negocio__pildora"
            :class="[`negocio__pildora--${s.id}`, { 'negocio__pildora--activa': semaforo === s.id }]"
            :title="s.nombre"
            @click="semaforo = s.id"
          ></button>
        </div>
      </div>
    </template>

    <main class="negocio__cuerpo">
      <h1 v-if="categoria && !enHome && vista === 'calugas'" class="negocio__titulo">{{ tituloVista }}</h1>

      <p v-if="error" class="negocio__aviso negocio__aviso--error">{{ error }}</p>
      <p v-else-if="cargando" class="negocio__aviso">Cargando…</p>
      <p v-else-if="!categorias.length" class="negocio__aviso">
        No hay categorías. Créalas en el admin, con su industria y sus fases.
      </p>
      <p v-else-if="categoria && !categoria.fases.length" class="negocio__aviso">
        La industria «{{ categoria.industria.nombre }}» no tiene fases definidas.
      </p>

      <p v-if="enHome && errorHome" class="negocio__aviso negocio__aviso--error">{{ errorHome }}</p>
      <home-gestor
        v-if="enHome && home && !error && categoria && categoria.fases.length"
        v-model:gestor="gestor"
        :unidades="homeVisible"
        :fases="categoria.fases"
        :semaforos="semaforos"
        :semaforo="semaforo"
        @ficha="abrirFicha"
        @enviar="abrirEnvio"
        @plazo="abrirPlazo"
        @cambio="cargar"
        @error="(m) => (errorHome = m)"
      />

      <template v-if="!enHome && tablero && !cargando && !error">
        <!-- Cabecera de las etapas con vista propia: nombre, descripción y SLA salen de la fase. -->
        <header v-if="vista !== 'calugas'" class="negocio__cabecera" :class="`negocio__cabecera--${vista}`">
          <div>
            <span v-if="vista === 'lanzamiento' && siguienteFase" class="negocio__contador">
              ETAPA PREVIA A {{ siguienteFase.nombre.toUpperCase() }}
            </span>
            <h2>{{ faseActual.nombre }} {{ categoria.nombre }}</h2>
            <p>{{ faseActual.descripcion }}</p>
          </div>
          <div class="negocio__cabecera-lado">
            <span v-if="faseActual.plazo_dias" class="negocio__badge negocio__badge--ambar">
              SLA {{ faseActual.plazo_dias }} día{{ faseActual.plazo_dias > 1 ? 's' : '' }}
            </span>
            <span class="negocio__badge">{{ unidadesVisibles.length }} UDN{{ unidadesVisibles.length === 1 ? '' : 's' }}</span>
            <button
              v-if="vista === 'lanzamiento' && siguienteFase"
              class="negocio__boton negocio__boton--gris"
              type="button"
              @click="elegirFase(siguienteFase.id)"
            >Ver {{ siguienteFase.nombre }} ➜</button>
          </div>
        </header>

        <p v-if="tablero.mostrados < tablero.total" class="negocio__aviso">
          Mostrando {{ tablero.mostrados }} de {{ tablero.total }} terrenos. Usa el buscador para acotar.
        </p>

        <!-- Supervisión: bandeja de control back-office -->
        <section v-if="vista === 'supervision'" class="negocio__caja">
          <h3>📋 Listado de Terrenos Pendientes de Supervisión <small>Control técnico de consistencia</small></h3>
          <div class="negocio__caja-cuerpo">
            <p v-if="!unidadesVisibles.length" class="negocio__tenue">{{ mensajeVacio }}</p>
            <table v-else class="negocio__tabla negocio__tabla--bandeja">
              <thead>
                <tr><th>Nombre</th><th>Comuna</th><th>Cliente</th><th>En la etapa</th><th class="negocio__centro">Acciones</th></tr>
              </thead>
              <tbody>
                <tr v-for="u in unidadesVisibles" :key="u.id">
                  <td><strong>{{ u.terreno.nombre }}</strong></td>
                  <td>{{ u.terreno.comuna || '—' }}</td>
                  <td>{{ u.cliente }}</td>
                  <td>
                    <span :class="{ 'negocio__tarde': fueraDePlazo(u) }">{{ diasEnFase(u) }} día{{ diasEnFase(u) === 1 ? '' : 's' }}</span>
                  </td>
                  <td class="negocio__centro negocio__botonera">
                    <button class="negocio__boton negocio__boton--chico" type="button" @click="abrirFicha(u.id)">👁️ Ver</button>
                    <button
                      v-if="faseAnterior"
                      class="negocio__boton negocio__boton--chico negocio__boton--rojo"
                      type="button"
                      @click="abrirMover(u, faseAnterior.id, 'Rechazar')"
                    >⬅ Rechazar</button>
                    <button
                      v-if="siguienteFase"
                      class="negocio__boton negocio__boton--chico negocio__boton--verde"
                      type="button"
                      :disabled="ocupado"
                      @click="aprobar(u)"
                    >✓ Aprobar ➜ {{ siguienteFase.nombre }}</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <!-- Seguimiento: días desde que la unidad entró a la etapa -->
        <section v-else-if="vista === 'seguimiento'" class="negocio__caja">
          <h3>⏱️ En espera de respuesta OVI <small>{{ unidadesVisibles.length }} UDNs · Seguimiento de las INFO enviadas</small></h3>
          <div class="negocio__caja-cuerpo">
            <p v-if="!unidadesVisibles.length" class="negocio__tenue">{{ mensajeVacio }}</p>
            <table v-else class="negocio__tabla negocio__tabla--bandeja">
              <thead>
                <tr><th class="negocio__centro">Estado</th><th>Unidad de Negocio</th><th>Última actualización</th><th class="negocio__centro">Acciones</th></tr>
              </thead>
              <tbody>
                <tr v-for="u in unidadesVisibles" :key="u.id">
                  <td class="negocio__centro">
                    <span class="negocio__pildora" :class="`negocio__pildora--${u.semaforo || 'sin-hito'}`" :title="u.semaforo ? nombreSemaforo(u.semaforo) : 'Sin hitos'"></span>
                  </td>
                  <td>
                    <strong>{{ u.cliente }} &amp; {{ u.terreno.nombre }}</strong>
                    <small class="negocio__bajada">{{ categoria.nombre }} · {{ estadoEnvio(u) }}</small>
                  </td>
                  <td>
                    {{ fecha(u.envio ? u.envio.fecha : u.fase_desde) }}
                    <span class="negocio__contador" :class="{ 'negocio__contador--rojo': esperaVencida(u) }">({{ diasEspera(u) }} días)</span>
                  </td>
                  <td class="negocio__centro negocio__botonera">
                    <button
                      v-if="u.accion"
                      class="negocio__boton negocio__boton--chico"
                      type="button"
                      :disabled="ocupado"
                      @click="cumplirDesdeTablero(u)"
                    >{{ u.accion.boton }}</button>
                    <button class="negocio__boton negocio__boton--chico negocio__boton--gris" type="button" @click.stop="abrirMenu($event, u)">Opciones ▾</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </section>

        <!-- OUT: descartadas, con su motivo y para reestablecer -->
        <div v-else-if="vista === 'out'">
          <p v-if="!unidadesVisibles.length" class="negocio__aviso">{{ mensajeVacio }}</p>
          <div class="negocio__tarjetas">
            <article v-for="u in unidadesVisibles" :key="u.id" class="negocio__tarjeta">
              <header>
                <strong>{{ u.terreno.nombre }}</strong>
                <span class="negocio__badge negocio__badge--rojo">{{ u.ultima ? u.ultima.tipo : 'Sin motivo registrado' }}</span>
              </header>
              <p><strong>{{ u.cliente }}</strong> · desde el {{ fecha(u.fase_desde) }}</p>
              <p v-if="u.ultima && u.ultima.nota" class="negocio__tenue">{{ u.ultima.nota }}</p>
              <div class="negocio__botonera">
                <button
                  class="negocio__boton negocio__boton--chico negocio__boton--blanco"
                  type="button"
                  @click="abrirMover(u, u.fase_anterior_id, 'Reestablecer')"
                >♻️ Reestablecer{{ nombreFase(u.fase_anterior_id) ? ` a ${nombreFase(u.fase_anterior_id)}` : '' }}</button>
                <button class="negocio__enlace" type="button" @click="abrirFicha(u.id)">Ficha</button>
              </div>
            </article>
          </div>
        </div>

        <!-- Vista genérica: terrenos con su carril de calugas (también Lanzamiento) -->
        <template v-else>
          <p v-if="!terrenosVisibles.length" class="negocio__aviso">{{ mensajeVacio }}</p>
          <section v-for="t in terrenosVisibles" :key="t.id" class="negocio__fila">
            <div class="negocio__terreno-columna">
              <div class="negocio__terreno" :class="claseTerreno(t)" :title="t.comuna || ''">
                <span>{{ t.nombre }}</span>
                <small v-if="vista === 'lanzamiento'">{{ [t.comuna, m2(t.superficie_m2)].filter(Boolean).join(' · ') }}</small>
                <small v-else-if="t.comuna">{{ t.comuna }}</small>
              </div>
              <button class="negocio__agregar" type="button" title="Asociar cliente" @click="abrirNueva(t)">+</button>
              <button
                v-if="vista === 'lanzamiento'"
                class="negocio__boton negocio__boton--chico negocio__boton--celeste"
                type="button"
                @click="abrirNueva(t)"
              >+ Asociar Comprador</button>
            </div>
            <div class="negocio__calugas">
              <div v-for="u in t.visibles" :key="u.id" class="negocio__caluga-envoltorio">
                <button
                  type="button"
                  class="negocio__caluga"
                  :class="`negocio__caluga--${u.semaforo || 'sin-hito'}`"
                  :title="`${tituloCaluga(u)} · Clic derecho para opciones`"
                  @click="abrirFicha(u.id)"
                  @contextmenu.prevent="abrirMenu($event, u)"
                >
                  <span class="negocio__caluga-gestor">
                    <span class="negocio__avatar"><i class="mdi mdi-account"></i></span>
                    <span>{{ u.gestor ? u.gestor.nombre.split(' ')[0] : '—' }}</span>
                  </span>
                  <span class="negocio__caluga-texto">
                    <strong>{{ u.cliente }}</strong>
                    <span v-if="vista === 'lanzamiento'">{{ fecha(u.fase_desde) }} ({{ diasEnFase(u) }}d)</span>
                    <span v-else>{{ fecha(u.creado) }}</span>
                    <small v-if="vista === 'lanzamiento' && u.semaforo">{{ nombreSemaforo(u.semaforo) }}</small>
                  </span>
                  <span v-if="u.docs_vencidos" class="negocio__caluga-alerta" :title="`${u.docs_vencidos} documento(s) vencido(s)`">!</span>
                </button>
                <div v-if="vista === 'lanzamiento'" class="negocio__caluga-pie">
                  <button v-if="u.accion" type="button" :disabled="ocupado" @click="cumplirDesdeTablero(u)">{{ u.accion.boton }}</button>
                  <span v-if="u.accion" class="negocio__tenue">·</span>
                  <button type="button" class="negocio__caluga-ficha" @click="abrirFicha(u.id)">Ficha</button>
                </div>
              </div>
            </div>
          </section>
        </template>
      </template>
    </main>

    <!-- Ficha de la unidad de negocio -->
    <div v-if="ficha" class="negocio__velo" @click.self="cerrarFicha">
      <div class="negocio__modal">
        <header class="negocio__modal-cabecera">
          <h2>UDN: {{ ficha.cliente.nombre }} &amp; {{ ficha.terreno.nombre }}<template v-if="ficha.gestor"> / {{ ficha.gestor.nombre }}</template></h2>
          <span class="negocio__etiqueta">{{ etiquetaFase(ficha.fase) }}</span>
          <button
            class="negocio__boton negocio__boton--ambar"
            type="button"
            @click="abrirComision({ id: ficha.id, cliente: ficha.cliente.nombre, terreno: ficha.terreno })"
          >+ Ver comisiones</button>
          <button class="negocio__boton negocio__boton--chico" type="button" @click="abrirEnvio(ficha.id)">✉️ Enviar INFO</button>
          <button
            class="negocio__boton negocio__boton--chico negocio__boton--gris"
            type="button"
            title="Historial y aperturas de las INFO enviadas"
            @click="abrirInforme(ficha.id)"
          >📊 Envíos INFO</button>
          <span v-if="ficha.semaforo" class="negocio__pildora" :class="`negocio__pildora--${ficha.semaforo}`" :title="nombreSemaforo(ficha.semaforo)"></span>
          <button class="negocio__cerrar" type="button" @click="cerrarFicha">&times;</button>
        </header>
        <p v-if="errorFicha" class="negocio__aviso negocio__aviso--error">{{ errorFicha }}</p>

        <div class="negocio__modal-cuerpo">
          <div class="negocio__grilla negocio__grilla--3">
            <section class="negocio__caja">
              <h3>Terreno</h3>
              <div class="negocio__caja-cuerpo">
                <p class="negocio__nombre">{{ ficha.terreno.nombre }}</p>
                <p><strong>Superficie disponible:</strong> {{ m2(ficha.terreno.superficie_m2) }}</p>
                <p><strong>Valor:</strong> {{ ficha.terreno.valor_uf_m2 != null ? `${numero(ficha.terreno.valor_uf_m2)} UF x m2` : '—' }}</p>
                <p><strong>Ubicación:</strong> {{ ficha.terreno.direccion || '—' }}</p>
                <p><strong>Comuna:</strong> {{ ficha.terreno.comuna || '—' }}</p>
                <p><strong>Región:</strong> {{ ficha.terreno.region || '—' }}</p>
                <p>Rol avalúo: {{ ficha.terreno.rol || '—' }}</p>
                <p class="negocio__separado"><strong>Zonificación:</strong> {{ ficha.terreno.zonificacion || '—' }}</p>
              </div>
            </section>

            <section class="negocio__caja">
              <h3>Empresa</h3>
              <div class="negocio__caja-cuerpo">
                <p class="negocio__nombre">{{ ficha.cliente.nombre }}</p>
                <p><strong>Tipo de Empresa:</strong> {{ ficha.cliente.tipo || '—' }}</p>
                <p>Rut: {{ ficha.cliente.rut || '—' }}</p>
                <p><strong>Dirección:</strong> {{ ficha.cliente.direccion || '—' }}</p>
                <p><strong>Nombre Representante:</strong> {{ ficha.cliente.representante || '—' }}</p>
                <p><strong>Correo:</strong> {{ ficha.cliente.email || '—' }}</p>
                <p><strong>Teléfono:</strong> {{ ficha.cliente.telefono || '—' }}</p>
              </div>
            </section>

            <section class="negocio__caja">
              <h3>Contactos</h3>
              <div class="negocio__caja-cuerpo">
                <div class="negocio__subpestanas">
                  <button
                    type="button"
                    :class="{ 'negocio__subpestana--activa': contactos === 'terreno' }"
                    @click="contactos = 'terreno'"
                  >Contactos Terreno</button>
                  <button
                    type="button"
                    :class="{ 'negocio__subpestana--activa': contactos === 'empresa' }"
                    @click="contactos = 'empresa'"
                  >Contactos Empresa</button>
                </div>
                <table class="negocio__tabla negocio__tabla--contactos">
                  <thead>
                    <tr><th>Nombre</th><th>Tipo de contacto</th><th>Teléfono</th><th>Celular</th><th>Correo electrónico</th></tr>
                  </thead>
                  <tbody>
                    <tr v-for="c in contactosVisibles" :key="c.id">
                      <td><strong>{{ c.nombre }}</strong></td>
                      <td>{{ c.tipo || '—' }}</td>
                      <td>{{ c.telefono || '—' }}</td>
                      <td>{{ c.celular || '—' }}</td>
                      <td><a v-if="c.email" :href="`mailto:${c.email}`">{{ c.email }}</a><template v-else>—</template></td>
                    </tr>
                  </tbody>
                </table>
                <p v-if="!contactosVisibles.length" class="negocio__tenue">
                  Sin contactos {{ contactos === 'terreno' ? 'del terreno' : 'de la empresa' }}.
                </p>
              </div>
            </section>
          </div>

          <div class="negocio__grilla negocio__grilla--2">
            <section class="negocio__caja">
              <h3>
                Documentación y Estado
                <button class="negocio__boton negocio__boton--translucido" type="button" @click="abrirPlanilla(true)">📑 Planilla Master</button>
              </h3>
              <div class="negocio__caja-cuerpo">
                <div class="negocio__barras">
                  <button
                    v-for="a in ficha.areas"
                    :key="a.id"
                    type="button"
                    class="negocio__barra-area"
                    :class="{ 'negocio__barra-area--activa': a.id === area }"
                    @click="area = a.id"
                  >
                    <span class="negocio__barra-pista">
                      <span
                        class="negocio__barra-relleno"
                        :class="{ 'negocio__barra-relleno--completa': a.exigibles && a.subidos === a.exigibles }"
                        :style="{ height: `${porcentaje(a)}%` }"
                      ></span>
                    </span>
                    <strong>{{ porcentaje(a) }}%</strong>
                    <small>{{ a.nombre }}</small>
                  </button>
                </div>

                <div class="negocio__docs">
                  <p class="negocio__docs-titulo">
                    Archivos de Área {{ areaElegida.nombre }}
                    <span v-if="areaElegida.exigibles">({{ porcentaje(areaElegida) }}% · {{ areaElegida.subidos }}/{{ areaElegida.exigibles }} requeridos al día):</span>
                    <span v-else class="negocio__tenue">(Inicia en etapa posterior):</span>
                  </p>
                  <p v-if="!docsEtapa.total" class="negocio__info">
                    <strong>{{ etiquetaFase(ficha.fase) }}</strong>
                    Esta etapa no exige documentos. Los de etapas siguientes se pueden anticipar.
                  </p>
                  <p v-if="!documentosArea.length" class="negocio__tenue">No hay documentos en esta área.</p>
                  <div v-for="d in documentosArea" :key="d.id" class="negocio__doc" :class="`negocio__doc--${d.estado}`">
                    <div class="negocio__doc-nombre" :title="d.descripcion">
                      <span class="negocio__punto">•</span>
                      <strong>{{ d.nombre }}:</strong>
                    </div>
                    <div class="negocio__doc-acciones">
                      <span class="negocio__badge" :class="badgeDocumento(d).clase" :title="tituloDocumento(d)">{{ badgeDocumento(d).texto }}</span>
                      <template v-if="d.url">
                        <a :href="d.url" target="_blank" rel="noopener">Ver</a>
                        <span class="negocio__tenue">·</span>
                        <a :href="d.url" :download="d.nombre_archivo || ''">Descargar</a>
                      </template>
                      <template v-else>
                        <label
                          class="negocio__subir"
                          :class="{ 'negocio__subir--boton': d.estado !== 'proximo', 'negocio__subir--rojo': d.estado === 'atrasado' || d.estado === 'vencido' }"
                        >
                          {{ d.estado === 'proximo' ? '+ Anticipar' : '+ Adjuntar' }}
                          <input type="file" :disabled="ocupado" @change="subir(d, $event)">
                        </label>
                        <button
                          v-if="d.estado !== 'proximo'"
                          class="negocio__enlace"
                          type="button"
                          @click="abrirPlazo({ unidad: ficha.id, item: { documento: d.id }, nombre: d.nombre, actual: d.vence })"
                        >Cambiar Plazo</button>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section class="negocio__caja">
              <h3>
                Bitácora
                <button class="negocio__boton negocio__boton--ambar" type="button" @click="abrirAnotar">
                  <i class="mdi mdi-plus"></i> Agregar Actividad
                </button>
              </h3>
              <div class="negocio__caja-cuerpo">
                <p v-if="!ficha.bitacora.length" class="negocio__tenue">Sin registros.</p>
                <table v-else class="negocio__tabla">
                  <thead>
                    <tr><th>Fecha creación</th><th>Gestor</th><th>Actividad</th><th>Descripción</th><th>Fecha tope</th><th>Acciones</th></tr>
                  </thead>
                  <tbody>
                    <tr v-for="r in ficha.bitacora" :key="r.id">
                      <td>{{ fecha(r.fecha) }}</td>
                      <td>{{ r.autor || '—' }}</td>
                      <td :class="{ 'negocio__hito': r.es_hito }">{{ r.tipo }}</td>
                      <td>
                        {{ r.nota }}
                        <span v-if="r.accion" class="negocio__ok"><i class="mdi mdi-check"></i> {{ r.accion }}</span>
                      </td>
                      <td>{{ r.fecha_tope ? fecha(`${r.fecha_tope}T12:00:00`) : '—' }}</td>
                      <td class="negocio__centro">
                        <button class="negocio__borrar" type="button" title="Borrar" :disabled="ocupado" @click="borrar(r)">
                          <i class="mdi mdi-delete"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>

    <!-- Registrar hito o acción operativa -->
    <div v-if="anotando" class="negocio__velo negocio__velo--encima" @click.self="anotando = null">
      <form class="negocio__modal negocio__modal--chico" @submit.prevent="anotar">
        <header class="negocio__modal-cabecera negocio__modal-cabecera--azul">
          <h2><i class="mdi mdi-plus"></i> Registrar Hito o Acción Operativa</h2>
          <button class="negocio__cerrar" type="button" @click="anotando = null">&times;</button>
        </header>
        <div class="negocio__modal-cuerpo negocio__formulario">
          <p v-if="errorFicha" class="negocio__aviso negocio__aviso--error">{{ errorFicha }}</p>
          <label>
            <span>Tipo de Acción:</span>
            <select v-model="anotando.tipo" required>
              <optgroup label="ACCIONES OPERATIVAS (Bitácora diaria · Sin cambio de semáforo)">
                <option v-for="t in operativas" :key="t.id" :value="t.id">{{ t.nombre }}</option>
              </optgroup>
              <optgroup label="HITOS FORMALES (Transiciones de estado · Cambian color)">
                <option v-for="t in hitos" :key="t.id" :value="t.id">
                  {{ t.nombre }}{{ t.semaforo ? ` (${nombreSemaforo(t.semaforo)})` : '' }}
                </option>
              </optgroup>
            </select>
          </label>
          <label v-if="accionesPendientes.length">
            <span>Marca como lista la acción de la etapa:</span>
            <select v-model="anotando.accion">
              <option :value="null">Ninguna</option>
              <option v-for="a in accionesPendientes" :key="a.id" :value="a.id">{{ a.nombre }}</option>
            </select>
          </label>
          <label>
            <span>Fecha Tope / Límite:</span>
            <campo-fecha v-model="anotando.fechaTope" />
          </label>
          <label>
            <span>Descripción / Detalle del Hito:</span>
            <textarea v-model="anotando.nota" rows="3" placeholder="Describe los acuerdos, personas presentes o condiciones acordadas..."></textarea>
          </label>
          <div class="negocio__pie">
            <button class="negocio__boton negocio__boton--gris" type="button" @click="anotando = null">Cancelar</button>
            <button class="negocio__boton" type="submit" :disabled="ocupado">Registrar Hito</button>
          </div>
        </div>
      </form>
    </div>

    <!-- Menú del clic derecho sobre una caluga -->
    <div
      v-if="menu"
      class="negocio__menu"
      :style="{ left: `${menu.x}px`, top: `${menu.y}px` }"
      @click.stop
      @contextmenu.prevent
    >
      <header>
        <span>{{ menu.unidad.cliente }}</span>
        <small>{{ menu.unidad.fase.numero ? `E${menu.unidad.fase.numero}` : menu.unidad.fase.nombre }}</small>
      </header>
      <button type="button" @click="desdeMenu(() => abrirFicha(menu.unidad.id))">📋 Resumen</button>
      <button type="button" @click="desdeMenu(() => abrirComision(menu.unidad))">✏️ Modificar Comisión y Valor</button>
      <button type="button" @click="desdeMenu(() => abrirComision(menu.unidad))">👤 Asignar Director de Negocios</button>
      <button type="button" @click="desdeMenu(() => abrirEnvio(menu.unidad.id))">✉️ Enviar INFO 1 / INFO 3</button>
      <button type="button" @click="desdeMenu(() => abrirInforme(menu.unidad.id))">📊 Ver Informe Envíos</button>
      <button type="button" @click="desdeMenu(() => abrirFicha(menu.unidad.id))">📤 Cargar Documento</button>
      <button type="button" @click="desdeMenu(() => abrirMover(menu.unidad, null, 'Mover de etapa'))">↪ Mover a otra etapa</button>
      <button
        v-if="siguienteDe(menu.unidad.fase)"
        type="button"
        class="negocio__menu-avanzar"
        @click="desdeMenu(() => aprobar(menu.unidad))"
      >🚀 Pasar a Siguiente Etapa</button>
    </div>

    <!-- Asignar Director de Negocios y Comisión -->
    <div v-if="comision" class="negocio__velo negocio__velo--encima" @click.self="comision = null">
      <form class="negocio__modal negocio__modal--mediano" @submit.prevent="guardarComision">
        <header class="negocio__modal-cabecera negocio__modal-cabecera--azul">
          <h2>✏️ Asignar Director de Negocios y Comisión · {{ comision.nombre }}</h2>
          <button class="negocio__cerrar" type="button" @click="comision = null">&times;</button>
        </header>
        <div class="negocio__modal-cuerpo negocio__formulario">
          <p v-if="errorMover" class="negocio__aviso negocio__aviso--error">{{ errorMover }}</p>
          <p class="negocio__nota-azul">
            <strong>ℹ️ Control de Comisiones Terranía:</strong>
            El director queda asignado a la unidad. Si indicas un porcentaje u observación, se agrega una fila a las comisiones otorgadas.
          </p>
          <div class="negocio__dos-columnas">
            <label>
              <span>Tipo Comisión:</span>
              <select v-model="comision.tipo">
                <option v-for="t in TIPOS_COMISION" :key="t" :value="t">{{ t }}</option>
              </select>
            </label>
            <label>
              <span>Director de Negocios:</span>
              <select v-model="comision.director" required>
                <option v-for="g in gestoresTodos" :key="g.id" :value="g.id">{{ g.nombre }}</option>
              </select>
            </label>
            <label>
              <span>Porcentaje Comisión (%):</span>
              <span class="negocio__paso">
                <button type="button" @click="pasoComision(-0.5)">−</button>
                <input v-model="comision.porcentaje" type="number" step="0.1" min="0.1" max="10" placeholder="2.0">
                <button type="button" @click="pasoComision(0.5)">+</button>
              </span>
            </label>
          </div>
          <label>
            <span>Observaciones / Condiciones:</span>
            <textarea v-model="comision.nota" rows="2" placeholder="Detalles del acuerdo comercial pactado..."></textarea>
          </label>

          <div>
            <p class="negocio__subtitulo">Comisiones Otorgadas:</p>
            <table class="negocio__tabla negocio__tabla--bandeja negocio__tabla--comisiones">
              <thead>
                <tr><th>Fecha</th><th>Director</th><th>P. Vendedora</th><th>P. Compradora</th><th>Nota</th></tr>
              </thead>
              <tbody>
                <tr v-if="!comision.filas.length"><td colspan="5" class="negocio__tenue">Sin comisiones otorgadas.</td></tr>
                <tr v-for="f in comision.filas" :key="f.id">
                  <td>{{ fecha(f.fecha) }}</td>
                  <td><strong>{{ f.director || '—' }}</strong></td>
                  <td :class="f.parte_vendedora ? 'negocio__ok' : 'negocio__tenue'">{{ f.parte_vendedora || '-' }}</td>
                  <td :class="f.parte_compradora ? 'negocio__ok' : 'negocio__tenue'">{{ f.parte_compradora || '-' }}</td>
                  <td>{{ f.nota }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="negocio__pie">
            <button class="negocio__boton negocio__boton--gris" type="button" @click="comision = null">Cancelar</button>
            <button class="negocio__boton" type="submit" :disabled="ocupado">Guardar Cambios</button>
          </div>
        </div>
      </form>
    </div>

    <!-- Mover de etapa: rechazar, reestablecer o mover desde el menú -->
    <div v-if="moviendo" class="negocio__velo negocio__velo--encima" @click.self="moviendo = null">
      <form class="negocio__modal negocio__modal--chico" @submit.prevent="guardarMover">
        <header class="negocio__modal-cabecera negocio__modal-cabecera--azul">
          <h2>{{ moviendo.titulo }} · {{ moviendo.nombre }}</h2>
          <button class="negocio__cerrar" type="button" @click="moviendo = null">&times;</button>
        </header>
        <div class="negocio__modal-cuerpo negocio__formulario">
          <p v-if="errorMover" class="negocio__aviso negocio__aviso--error">{{ errorMover }}</p>
          <label>
            <span>Mover a la etapa:</span>
            <select v-model="moviendo.fase" required>
              <option v-for="f in categoria.fases" :key="f.id" :value="f.id" :disabled="f.id === moviendo.desde">{{ etiquetaFase(f) }}</option>
            </select>
          </label>
          <label>
            <span>Registrar en la bitácora:</span>
            <select v-model="moviendo.tipo">
              <option :value="null">Nada, sólo mover</option>
              <optgroup label="HITOS FORMALES (Cambian color)">
                <option v-for="t in tiposCategoria.filter((x) => x.es_hito)" :key="t.id" :value="t.id">{{ t.nombre }}</option>
              </optgroup>
              <optgroup label="ACCIONES OPERATIVAS">
                <option v-for="t in tiposCategoria.filter((x) => !x.es_hito)" :key="t.id" :value="t.id">{{ t.nombre }}</option>
              </optgroup>
            </select>
          </label>
          <label v-if="moviendo.tipo">
            <span>Descripción / Motivo:</span>
            <textarea v-model="moviendo.nota" rows="2"></textarea>
          </label>
          <div class="negocio__pie">
            <button class="negocio__boton negocio__boton--gris" type="button" @click="moviendo = null">Cancelar</button>
            <button class="negocio__boton" type="submit" :disabled="ocupado">{{ moviendo.titulo }}</button>
          </div>
        </div>
      </form>
    </div>

    <planilla-master
      v-if="planilla && (!planilla.editable || ficha)"
      :documentos="planilla.editable ? ficha.documentos : planilla.documentos"
      :areas="areasDocumento"
      :editable="planilla.editable"
      :nombre="planilla.editable ? `${ficha.cliente.nombre} & ${ficha.terreno.nombre}` : ''"
      :ocupado="ocupado"
      :error="errorPlanilla"
      @cerrar="planilla = null"
      @editar="editarPlanilla"
      @subir="subirDesdePlanilla"
    />

    <envio-info
      v-if="envio"
      :unidad="envio.unidad"
      :nombre="envio.nombre"
      :cliente="envio.cliente"
      :areas="areasDocumento"
      @cerrar="envio = null"
      @enviado="enviado"
    />

    <informe-envios
      v-if="informe"
      :unidad="informe.unidad || null"
      :categoria="informe.categoria || null"
      :titulo="informe.titulo"
      @cerrar="informe = null"
      @ficha="(id) => { informe = null; abrirFicha(id); }"
    />

    <!-- Cambiar plazo de un documento o una acción -->
    <div v-if="plazo" class="negocio__velo negocio__velo--encima" @click.self="plazo = null">
      <form class="negocio__modal negocio__modal--chico" @submit.prevent="guardarPlazo">
        <header class="negocio__modal-cabecera negocio__modal-cabecera--azul">
          <h2>Cambiar Plazo · {{ plazo.nombre }}</h2>
          <button class="negocio__cerrar" type="button" @click="plazo = null">&times;</button>
        </header>
        <div class="negocio__modal-cuerpo negocio__formulario">
          <p v-if="errorMover" class="negocio__aviso negocio__aviso--error">{{ errorMover }}</p>
          <p class="negocio__tenue">Plazo actual: {{ fecha(plazo.actual) }}</p>
          <label><span>Nueva fecha límite:</span><campo-fecha v-model="plazo.vence" required /></label>
          <label><span>Razón del cambio:</span><textarea v-model="plazo.razon" rows="2" required></textarea></label>
          <div class="negocio__pie">
            <button class="negocio__boton negocio__boton--gris" type="button" @click="plazo = null">Cancelar</button>
            <button class="negocio__boton" type="submit" :disabled="ocupado">Guardar</button>
          </div>
        </div>
      </form>
    </div>

    <!-- Nueva unidad de negocio: cliente + terreno -->
    <div v-if="nuevaUnidad" class="negocio__velo" @click.self="nuevaUnidad = null">
      <form class="negocio__modal negocio__modal--chico" @submit.prevent="crearUnidad">
        <header class="negocio__modal-cabecera negocio__modal-cabecera--azul">
          <h2>
            {{ nuevaUnidad.fijo ? `Asociar cliente · ${nuevaUnidad.terreno.nombre}` : `Nueva Unidad de Negocio · ${categoria.nombre}` }}
          </h2>
          <button class="negocio__cerrar" type="button" @click="nuevaUnidad = null">&times;</button>
        </header>
        <div class="negocio__modal-cuerpo negocio__formulario">
          <p v-if="errorNueva" class="negocio__aviso negocio__aviso--error">{{ errorNueva }}</p>

          <template v-if="!nuevaUnidad.fijo">
            <label>
              <span>Terreno</span>
              <input v-model="nuevaUnidad.buscarTerreno" type="search" placeholder="Buscar por nombre, comuna o rol" @input="buscarTerrenosLuego">
            </label>
            <select v-model="nuevaUnidad.terrenoId" size="6" required>
              <option v-for="t in terrenos" :key="t.id" :value="t.id">
                {{ t.nombre }}{{ t.comuna ? ` · ${t.comuna}` : '' }}{{ t.rol ? ` · rol ${t.rol}` : '' }}
              </option>
            </select>
          </template>

          <template v-if="!nuevaUnidad.crear">
            <label>
              <span>Cliente</span>
              <input v-model="nuevaUnidad.buscar" type="search" placeholder="Buscar por nombre o rut" @input="buscarClientesLuego">
            </label>
            <select v-model="nuevaUnidad.cliente" size="6" required>
              <option v-for="c in clientes" :key="c.id" :value="c.id">{{ c.nombre }}{{ c.rut ? ` · ${c.rut}` : '' }}</option>
            </select>
          </template>
          <button class="negocio__enlace" type="button" @click="nuevaUnidad.crear = !nuevaUnidad.crear">
            {{ nuevaUnidad.crear ? 'Elegir un cliente existente' : '¿No está? Crear cliente nuevo' }}
          </button>
          <template v-if="nuevaUnidad.crear">
            <label><span>Nombre</span><input v-model="nuevaUnidad.datos.nombre" required></label>
            <label><span>Tipo de empresa</span><input v-model="nuevaUnidad.datos.tipo" placeholder="Inmobiliaria, Propietario…"></label>
            <label><span>Rut</span><input v-model="nuevaUnidad.datos.rut"></label>
            <label><span>Dirección</span><input v-model="nuevaUnidad.datos.direccion"></label>
            <label><span>Representante</span><input v-model="nuevaUnidad.datos.representante"></label>
            <label><span>Correo</span><input v-model="nuevaUnidad.datos.email" type="email"></label>
            <label><span>Teléfono</span><input v-model="nuevaUnidad.datos.telefono"></label>
          </template>

          <p class="negocio__tenue">
            Entra a la etapa inicial: <strong>{{ etapaInicial ? etiquetaFase(etapaInicial) : '—' }}</strong>
          </p>

          <div class="negocio__pie">
            <button class="negocio__boton negocio__boton--gris" type="button" @click="nuevaUnidad = null">Cancelar</button>
            <button class="negocio__boton" type="submit" :disabled="ocupado">Asociar</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {
  cerrarSesion, mensajeError, negocioAnotar, negocioAvanzar, negocioBorrarRegistro,
  negocioCambiarPlazo, negocioCategorias, negocioClientes, negocioCrearCliente, negocioCrearUnidad,
  negocioComisiones, negocioCumplirAccion, negocioDocumentosIndustria, negocioEditarPlanilla,
  negocioGestores, negocioGuardarComision, negocioHome, negocioMoverFase, negocioSubirDocumento,
  negocioTablero, negocioTerrenos, negocioUnidad,
} from '../../services/comandoApi';

const FECHA = new Intl.DateTimeFormat('es-CL', { day: '2-digit', month: '2-digit', year: 'numeric' });
const FECHA_HORA = new Intl.DateTimeFormat('es-CL', { dateStyle: 'short', timeStyle: 'short' });
const NUMERO = new Intl.NumberFormat('es-CL', { maximumFractionDigits: 2 });
// Los tipos del modal de comisión: el porcentaje va a la parte que corresponde.
const TIPOS_COMISION = ['Parte Compradora', 'Parte Vendedora', 'Ambas Partes (Bilateral)'];

import CampoFecha from './CampoFecha.vue';
import EnvioInfo from './EnvioInfo.vue';
import HomeGestor from './HomeGestor.vue';
import InformeEnvios from './InformeEnvios.vue';
import PlanillaMaster from './PlanillaMaster.vue';

export default {
  name: 'TableroNegocio',

  components: {
    CampoFecha, EnvioInfo, HomeGestor, InformeEnvios, PlanillaMaster,
  },

  data() {
    return {
      TIPOS_COMISION,
      categorias: [],
      semaforos: [],
      categoria: null,
      fase: null,
      q: '',
      // Filtros de la barra de gestores y del semáforo: se aplican sobre lo cargado.
      gestor: null,
      semaforo: undefined,
      tablero: null,
      cargando: true,
      error: '',
      ficha: null,
      errorFicha: '',
      area: null,
      anotando: null,
      plazo: null,
      enHome: true,
      home: null,
      errorHome: '',
      moviendo: null,
      contactos: 'terreno',
      menu: null,
      comision: null,
      planilla: null,
      errorPlanilla: '',
      envio: null,
      informe: null,
      areasDocumento: [],
      gestoresTodos: [],
      errorMover: '',
      nuevaUnidad: null,
      errorNueva: '',
      clientes: [],
      terrenos: [],
      ocupado: false,
    };
  },

  computed: {
    etapaInicial() {
      return this.enFlujo[0] || null;
    },
    faseActual() {
      return this.categoria && this.categoria.fases.find((f) => f.id === this.fase);
    },
    // Las etapas sin vista propia usan la genérica: terrenos con sus calugas.
    vista() {
      return this.faseActual ? this.faseActual.vista : 'calugas';
    },
    // Vecinas en el flujo, saltándose las que están fuera de él (OUT).
    enFlujo() {
      return this.categoria ? this.categoria.fases.filter((f) => !f.fuera_de_flujo) : [];
    },
    siguienteFase() {
      const i = this.enFlujo.findIndex((f) => f.id === this.fase);
      return i >= 0 ? this.enFlujo[i + 1] : null;
    },
    faseAnterior() {
      const i = this.enFlujo.findIndex((f) => f.id === this.fase);
      return i > 0 ? this.enFlujo[i - 1] : null;
    },
    tiposCategoria() {
      return this.categoria ? this.categoria.tipos_actividad : [];
    },
    unidadesVisibles() {
      return this.terrenosVisibles.flatMap((t) => t.visibles.map((u) => ({ ...u, terreno: t })));
    },
    // El buscador también acota el HOME, por terreno, comuna o cliente.
    homeVisible() {
      const q = this.q.trim().toLowerCase();
      if (!q) return this.home;
      return this.home.filter((u) => [u.terreno.nombre, u.terreno.comuna, u.cliente]
        .some((texto) => texto && texto.toLowerCase().includes(q)));
    },
    urgentes() {
      return (this.home || []).filter((u) => u.urgencia.nivel === 'critica' || u.urgencia.nivel === 'alta').length;
    },
    tituloVista() {
      const fase = this.categoria.fases.find((f) => f.id === this.fase);
      return `${fase ? fase.nombre : ''} - ${this.categoria.nombre}`.toUpperCase();
    },
    gestores() {
      const vistos = new Map();
      const unidades = this.enHome
        ? (this.home || [])
        : (this.tablero ? this.tablero.terrenos.flatMap((t) => t.unidades) : []);
      unidades.forEach((u) => { if (u.gestor) vistos.set(u.gestor.id, u.gestor); });
      return [...vistos.values()].sort((a, b) => a.nombre.localeCompare(b.nombre));
    },
    mensajeVacio() {
      if (this.gestor !== null || this.semaforo !== undefined || this.q) {
        return 'Ninguna unidad de negocio calza con el filtro.';
      }
      return `No hay unidades de negocio de ${this.categoria.nombre} en ${this.faseActual.nombre}. Créala con «+ Unidad de Negocio».`;
    },
    // Con un filtro de gestor o semáforo, se esconden los terrenos que quedan sin calugas.
    terrenosVisibles() {
      if (!this.tablero) return [];
      const filtra = this.gestor !== null || this.semaforo !== undefined;
      return this.tablero.terrenos
        .map((t) => ({
          ...t,
          visibles: t.unidades.filter((u) => (
            (this.gestor === null || (u.gestor && u.gestor.id === this.gestor))
            && (this.semaforo === undefined || u.semaforo === this.semaforo)
          )),
        }))
        .filter((t) => !filtra || t.visibles.length);
    },
    documentosArea() {
      return this.ficha ? this.ficha.documentos.filter((d) => d.area === this.area) : [];
    },
    accionesPendientes() {
      return this.ficha ? this.ficha.acciones.filter((a) => !a.realizada) : [];
    },
    contactosVisibles() {
      return this.contactos === 'terreno' ? this.ficha.contactos_terreno : this.ficha.contactos_empresa;
    },
    areaElegida() {
      return this.ficha.areas.find((a) => a.id === this.area) || this.ficha.areas[0];
    },
    docsEtapa() {
      const propios = this.ficha.documentos.filter((d) => d.fase.id === this.ficha.fase.id);
      return { total: propios.length, subidos: propios.filter((d) => d.estado === 'validado').length };
    },
    operativas() {
      return this.ficha ? this.ficha.tipos_actividad.filter((t) => !t.es_hito) : [];
    },
    hitos() {
      return this.ficha ? this.ficha.tipos_actividad.filter((t) => t.es_hito) : [];
    },
  },

  beforeUnmount() {
    window.removeEventListener('click', this.cerrarMenu);
  },

  async mounted() {
    window.addEventListener('click', this.cerrarMenu);
    try {
      const { categorias, semaforos, areas } = await negocioCategorias();
      this.categorias = categorias;
      this.semaforos = semaforos;
      this.areasDocumento = areas;
    } catch (e) {
      this.error = mensajeError(e);
      this.cargando = false;
      return;
    }
    const guardada = Number(new URLSearchParams(window.location.search).get('categoria'));
    const inicial = this.categorias.find((c) => c.id === guardada) || this.categorias[0];
    if (inicial) this.elegirCategoria(inicial);
    else this.cargando = false;
  },

  methods: {
    elegirCategoria(categoria) {
      this.categoria = categoria;
      // Como el mockup, la categoría abre en el HOME; la etapa queda en la primera.
      this.enHome = true;
      this.fase = categoria.fases.length ? categoria.fases[0].id : null;
      this.gestor = null;
      this.semaforo = undefined;
      const url = new URL(window.location.href);
      url.searchParams.set('categoria', categoria.id);
      window.history.replaceState(null, '', url);
      this.cargar();
    },

    elegirFase(fase) {
      this.enHome = false;
      this.fase = fase;
      this.cargar();
    },

    elegirHome() {
      this.enHome = true;
      this.cargar();
    },

    buscarLuego() {
      clearTimeout(this.esperaBusqueda);
      this.esperaBusqueda = setTimeout(() => this.cargar(), 300);
    },

    // Sólo vale la última respuesta: una búsqueda lenta no pisa a la siguiente.
    // El HOME se carga siempre: de él sale el contador de urgentes de la pestaña.
    async cargar() {
      const turno = (this.turno = (this.turno || 0) + 1);
      if (this.fase === null) {
        this.tablero = null;
        this.home = null;
        this.cargando = false;
        return;
      }
      this.cargando = true;
      this.error = '';
      this.errorHome = '';
      try {
        const [home, tablero] = await Promise.all([
          negocioHome(this.categoria.id),
          this.enHome ? null : negocioTablero(this.categoria.id, { fase: this.fase, q: this.q || undefined }),
        ]);
        if (turno === this.turno) {
          this.home = home;
          this.tablero = tablero;
        }
      } catch (e) {
        if (turno === this.turno) this.error = mensajeError(e);
      } finally {
        if (turno === this.turno) this.cargando = false;
      }
    },

    etiquetaFase(f) {
      const nombre = f.nombre.toUpperCase();
      return f.numero ? `${f.numero}: ${nombre}` : nombre;
    },

    nombreSemaforo(id) {
      const s = this.semaforos.find((x) => x.id === id);
      return s ? s.nombre : id;
    },

    tituloCaluga(u) {
      const estado = u.semaforo ? this.nombreSemaforo(u.semaforo) : 'Sin hitos';
      return `${u.cliente} · ${u.fase.nombre} · ${estado}`;
    },

    claseTerreno(t) {
      if (t.unidades.some((u) => u.docs_vencidos)) return 'negocio__terreno--rojo';
      return t.unidades.length ? 'negocio__terreno--cian' : 'negocio__terreno--blanco';
    },

    async abrirFicha(id) {
      this.errorFicha = '';
      try {
        this.mostrarFicha(await negocioUnidad(id));
      } catch (e) {
        this.error = mensajeError(e);
      }
    },

    // Abre en el área de los documentos de la etapa actual, como el mockup.
    mostrarFicha(ficha) {
      const nueva = !this.ficha || this.ficha.id !== ficha.id;
      this.ficha = ficha;
      if (nueva) {
        const deEtapa = ficha.documentos.find((d) => d.fase.id === ficha.fase.id);
        const exigible = ficha.areas.find((a) => a.exigibles);
        this.area = (deEtapa && deEtapa.area) || (exigible || ficha.areas[0]).id;
        this.contactos = 'terreno';
      }
    },

    cerrarFicha() {
      this.ficha = null;
      this.planilla = null;
      this.anotando = null;
      this.cargar();
    },

    // Envuelve cada cambio sobre la ficha: bloquea botones y muestra el porqué si falla.
    async enFicha(operacion) {
      this.ocupado = true;
      this.errorFicha = '';
      try {
        this.mostrarFicha(await operacion());
        return true;
      } catch (e) {
        this.errorFicha = mensajeError(e);
        return false;
      } finally {
        this.ocupado = false;
      }
    },

    avanzar() {
      this.enFicha(() => negocioAvanzar(this.ficha.id));
    },

    abrirMenu(evento, unidad) {
      // Que no se salga de la pantalla, como en el mockup.
      const x = Math.min(evento.clientX, window.innerWidth - 260);
      const y = Math.min(evento.clientY, window.innerHeight - 260);
      this.menu = { x, y, unidad: { ...unidad, terreno: this.terrenoDe(unidad) } };
    },

    cerrarMenu() {
      this.menu = null;
    },

    desdeMenu(accion) {
      this.menu = null;
      accion();
    },

    terrenoDe(unidad) {
      return this.tablero.terrenos.find((t) => t.unidades.some((u) => u.id === unidad.id));
    },

    siguienteDe(fase) {
      if (fase.fuera_de_flujo) return null;
      const i = this.enFlujo.findIndex((f) => f.id === fase.id);
      return i >= 0 ? this.enFlujo[i + 1] : null;
    },

    // Desde la ficha es la planilla de la unidad; desde la sub-barra, el catálogo.
    async abrirPlanilla(editable) {
      this.errorPlanilla = '';
      if (editable) {
        this.planilla = { editable: true };
        return;
      }
      try {
        this.planilla = { editable: false, documentos: await negocioDocumentosIndustria(this.categoria.id) };
      } catch (e) {
        this.error = mensajeError(e);
      }
    },

    async enPlanilla(operacion) {
      this.ocupado = true;
      this.errorPlanilla = '';
      try {
        this.mostrarFicha(await operacion());
      } catch (e) {
        this.errorPlanilla = mensajeError(e);
      } finally {
        this.ocupado = false;
      }
    },

    editarPlanilla(documento, campos) {
      this.enPlanilla(() => negocioEditarPlanilla(this.ficha.id, documento, campos));
    },

    subirDesdePlanilla(documento, archivo) {
      this.enPlanilla(() => negocioSubirDocumento(this.ficha.id, documento, archivo));
    },

    async abrirComision(unidad) {
      this.errorMover = '';
      this.comision = {
        id: unidad.id,
        nombre: `${unidad.cliente} & ${unidad.terreno.nombre}`,
        tipo: TIPOS_COMISION[0],
        director: null,
        porcentaje: '',
        nota: '',
        filas: [],
      };
      try {
        const [gestores, datos] = await Promise.all([negocioGestores(), negocioComisiones(unidad.id)]);
        this.gestoresTodos = gestores;
        this.comision.director = datos.director ? datos.director.id : null;
        this.comision.filas = datos.comisiones;
      } catch (e) {
        this.errorMover = mensajeError(e);
      }
    },

    // Los − y + del mockup: de 0,5 en 0,5, entre 0,1 y 10.
    pasoComision(delta) {
      const actual = parseFloat(this.comision.porcentaje) || 2.0;
      this.comision.porcentaje = Math.max(0.1, Math.min(10, actual + delta)).toFixed(1);
    },

    async guardarComision() {
      const { id, tipo, director, porcentaje, nota } = this.comision;
      const texto = porcentaje ? `${Number(porcentaje).toFixed(1)}%` : '';
      this.ocupado = true;
      this.errorMover = '';
      try {
        await negocioGuardarComision(id, {
          director,
          nota,
          parte_vendedora: tipo === TIPOS_COMISION[0] ? '' : texto,
          parte_compradora: tipo === TIPOS_COMISION[1] ? '' : texto,
        });
        this.comision = null;
        if (this.ficha && this.ficha.id === id) this.mostrarFicha(await negocioUnidad(id));
        await this.cargar();
      } catch (e) {
        this.errorMover = mensajeError(e);
      } finally {
        this.ocupado = false;
      }
    },

    abrirMover(unidad, destino, titulo) {
      this.errorMover = '';
      this.moviendo = {
        id: unidad.id,
        nombre: unidad.terreno ? `${unidad.cliente} & ${unidad.terreno.nombre}` : unidad.cliente,
        desde: unidad.fase.id,
        fase: destino,
        tipo: null,
        nota: '',
        titulo,
      };
    },

    async guardarMover() {
      const { id, fase, tipo, nota } = this.moviendo;
      this.ocupado = true;
      this.errorMover = '';
      try {
        const ficha = await negocioMoverFase(id, fase, { tipo, nota });
        this.moviendo = null;
        if (this.ficha && this.ficha.id === id) this.mostrarFicha(ficha);
        else this.cargar();
      } catch (e) {
        this.errorMover = mensajeError(e);
      } finally {
        this.ocupado = false;
      }
    },

    // Acciones desde las vistas de etapa: la tabla se recarga con el resultado.
    async desdeTablero(operacion) {
      this.ocupado = true;
      this.error = '';
      try {
        await operacion();
        await this.cargar();
      } catch (e) {
        this.error = mensajeError(e);
      } finally {
        this.ocupado = false;
      }
    },

    aprobar(unidad) {
      this.desdeTablero(() => negocioAvanzar(unidad.id));
    },

    // La acción que cumple el correo (despachar la INFO 1) abre el envío, no la bitácora.
    cumplirDesdeTablero(unidad) {
      if (unidad.accion.evento === 'info1_enviada') this.abrirEnvio(unidad.id);
      else this.desdeTablero(() => negocioCumplirAccion(unidad.id, unidad.accion.id));
    },

    // El nombre sale de la unidad a mano (ficha, tablero u HOME); si no, se pide.
    async abrirEnvio(id) {
      let unidad = this.unidadConocida(id);
      if (!unidad) {
        try {
          const f = await negocioUnidad(id);
          unidad = { cliente: f.cliente.nombre, nombre: `${f.cliente.nombre} & ${f.terreno.nombre}` };
        } catch (e) {
          this.error = mensajeError(e);
          return;
        }
      }
      this.envio = { unidad: id, ...unidad };
    },

    unidadConocida(id) {
      if (this.ficha && this.ficha.id === id) {
        return { cliente: this.ficha.cliente.nombre, nombre: `${this.ficha.cliente.nombre} & ${this.ficha.terreno.nombre}` };
      }
      const desdeTablero = this.tablero && this.tablero.terrenos
        .flatMap((t) => t.unidades.map((u) => ({ ...u, terreno: t })))
        .find((u) => u.id === id);
      const u = desdeTablero || (this.home || []).find((x) => x.id === id);
      return u ? { cliente: u.cliente, nombre: `${u.cliente} & ${u.terreno.nombre}` } : null;
    },

    abrirInforme(id) {
      const unidad = this.unidadConocida(id);
      this.informe = { unidad: id, titulo: unidad ? unidad.nombre : '' };
    },

    // Si algún destinatario falló, se avisa; el detalle queda en el informe.
    enviado(respuesta) {
      this.envio = null;
      const ultima = respuesta.destinatarios.length ? respuesta.destinatarios[0].fecha : null;
      const fallidos = respuesta.destinatarios.filter((d) => d.fecha === ultima && d.error);
      const aviso = fallidos.length
        ? `No salió a ${fallidos.map((d) => d.email).join(', ')}. Revisa el informe de envíos.`
        : '';
      if (this.ficha && this.ficha.id === respuesta.ficha.id) {
        this.mostrarFicha(respuesta.ficha);
        this.errorFicha = aviso;
      } else {
        this.error = aviso;
      }
      this.cargar();
    },

    // Seguimiento cuenta desde el último envío de INFO; sin envío, desde la entrada a la etapa.
    diasEspera(unidad) {
      const desde = unidad.envio ? unidad.envio.fecha : unidad.fase_desde;
      return Math.floor((Date.now() - new Date(desde)) / 86400000);
    },

    esperaVencida(unidad) {
      return unidad.fase.plazo_dias != null && !(unidad.envio && unidad.envio.clic)
        && this.diasEspera(unidad) > unidad.fase.plazo_dias;
    },

    estadoEnvio(unidad) {
      const e = unidad.envio;
      if (!e) return 'Sin INFO enviada';
      const nivel = e.nivel === 'info3' ? 'Info 3' : 'Info 1';
      if (e.clic) return `Pidió más información (OVI) el ${this.fecha(e.clic)}`;
      return e.abierto ? `${nivel} abierta` : `Hito ${nivel} enviada`;
    },

    diasEnFase(unidad) {
      return Math.floor((Date.now() - new Date(unidad.fase_desde)) / 86400000);
    },

    fueraDePlazo(unidad) {
      return unidad.fase.plazo_dias != null && this.diasEnFase(unidad) > unidad.fase.plazo_dias;
    },

    nombreFase(id) {
      const f = this.categoria.fases.find((x) => x.id === id);
      return f ? f.nombre : '';
    },

    async subir(documento, evento) {
      const archivo = evento.target.files[0];
      evento.target.value = '';
      if (archivo) await this.enFicha(() => negocioSubirDocumento(this.ficha.id, documento.id, archivo));
    },

    abrirPlazo({ unidad, item, nombre, actual }) {
      this.errorMover = '';
      this.plazo = { unidad, item, nombre, actual, vence: '', razon: '' };
    },

    // Sirve a la ficha y al HOME: refresca el que esté a la vista.
    async guardarPlazo() {
      const { unidad, item, vence, razon } = this.plazo;
      this.ocupado = true;
      this.errorMover = '';
      try {
        const ficha = await negocioCambiarPlazo(unidad, item, vence, razon);
        this.plazo = null;
        if (this.ficha && this.ficha.id === unidad) this.mostrarFicha(ficha);
        else await this.cargar();
      } catch (e) {
        this.errorMover = mensajeError(e);
      } finally {
        this.ocupado = false;
      }
    },

    etiquetaEtapa(fase) {
      return fase.numero ? `Etapa ${fase.numero}` : fase.nombre;
    },

    badgeDocumento(d) {
      const etapa = this.etiquetaEtapa(d.fase);
      switch (d.estado) {
        case 'validado': return { texto: '✓ Validado', clase: 'negocio__badge--ok' };
        case 'requerido': return { texto: `Requerido ${etapa}`, clase: 'negocio__badge--ambar' };
        case 'vencido': return { texto: `Vencido ${etapa}`, clase: 'negocio__badge--rojo' };
        case 'atrasado': return { texto: `Atrasado (${etapa})`, clase: 'negocio__badge--rojo' };
        default: return { texto: `Próximo (${etapa})`, clase: '' };
      }
    },

    tituloDocumento(d) {
      if (d.subido) return `Subido el ${this.fecha(d.subido)} por ${d.subido_por || '—'}${d.a_tiempo ? '' : ' (fuera de plazo)'}`;
      if (!d.vence) return `${d.plazo_dias} días desde que la unidad entra a la etapa`;
      return `Vence el ${this.fecha(d.vence)}${d.prorroga ? ` · prorrogado: ${d.prorroga}` : ''}`;
    },

    abrirAnotar() {
      this.errorFicha = '';
      this.anotando = {
        tipo: this.operativas.length ? this.operativas[0].id : null,
        accion: null,
        fechaTope: '',
        nota: '',
      };
    },

    async anotar() {
      const ok = await this.enFicha(() => negocioAnotar(this.ficha.id, this.anotando));
      if (ok) this.anotando = null;
    },

    borrar(registro) {
      if (!window.confirm(`¿Borrar «${registro.tipo}» del ${this.fecha(registro.fecha)}?`)) return;
      this.enFicha(() => negocioBorrarRegistro(registro.id));
    },

    // Con terreno es el (+) de una fila; sin él, el botón de la categoría, que lo busca.
    abrirNueva(terreno = null) {
      this.errorNueva = '';
      this.nuevaUnidad = {
        fijo: Boolean(terreno),
        terreno,
        terrenoId: terreno ? terreno.id : null,
        buscarTerreno: '',
        buscar: '',
        cliente: null,
        crear: false,
        datos: { nombre: '', tipo: '', rut: '', direccion: '', representante: '', email: '', telefono: '' },
      };
      this.buscarClientes();
      if (!terreno) this.buscarTerrenos();
    },

    buscarTerrenosLuego() {
      clearTimeout(this.esperaTerrenos);
      this.esperaTerrenos = setTimeout(() => this.buscarTerrenos(), 300);
    },

    async buscarTerrenos() {
      try {
        this.terrenos = await negocioTerrenos(this.nuevaUnidad.buscarTerreno || undefined);
      } catch (e) {
        this.errorNueva = mensajeError(e);
      }
    },

    buscarClientesLuego() {
      clearTimeout(this.esperaClientes);
      this.esperaClientes = setTimeout(() => this.buscarClientes(), 300);
    },

    async buscarClientes() {
      try {
        this.clientes = await negocioClientes(this.nuevaUnidad.buscar || undefined);
      } catch (e) {
        this.errorNueva = mensajeError(e);
      }
    },

    async crearUnidad() {
      const n = this.nuevaUnidad;
      this.ocupado = true;
      this.errorNueva = '';
      try {
        // Si se crea el cliente y falla la unidad, el cliente queda elegido para reintentar.
        if (n.crear) {
          const cliente = await negocioCrearCliente(n.datos);
          n.cliente = cliente.id;
          n.crear = false;
          this.clientes = [cliente];
        }
        const ficha = await negocioCrearUnidad(this.categoria.id, n.terrenoId, n.cliente);
        this.nuevaUnidad = null;
        this.mostrarFicha(ficha);
        this.cargar();
      } catch (e) {
        this.errorNueva = mensajeError(e);
      } finally {
        this.ocupado = false;
      }
    },

    async salir() {
      await cerrarSesion();
      window.location.assign('/login');
    },

    porcentaje(area) {
      return area.exigibles ? Math.round((area.subidos * 100) / area.exigibles) : 0;
    },

    fecha(valor) {
      return valor ? FECHA.format(new Date(valor)) : '—';
    },

    fechaHora(valor) {
      return valor ? FECHA_HORA.format(new Date(valor)) : '—';
    },

    numero(valor) {
      return NUMERO.format(valor);
    },

    m2(valor) {
      return valor != null ? `${NUMERO.format(Math.round(valor))} m²` : '—';
    },
  },
};
</script>
